import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EmptyColumnChartCustomAttributes } from '@ddt-web/chart';
import { TabData } from '@ddt-web/data-service';

import { InsightsChartHelper } from '../../helpers/insights-chart-helper';

@Component({
	selector: 'ate-empty-column-chart',
	templateUrl: './empty-column-chart.component.html',
	styleUrls: ['./empty-column-chart.component.scss']
})
export class EmptyColumnChartComponent implements OnChanges, AfterViewInit {
	public subHeaderValue: string;
	public subHeaderText: string;
	public categories: Array<any> = [];
	public emptyColumnChartAttributes: EmptyColumnChartCustomAttributes;

	@Input() public sectionTitle: string;
	@Input() public showSubHeaderContent: boolean;
	@Input() public data: TabData;
	@Input() public type: string;
	@Input() public height: number;
	@Input('data-index') public dataIndex?: number;
	@Input() public selectedPortfolioIndex: number;

	constructor(private element: ElementRef, private ref: ChangeDetectorRef) { }

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.data) {
			const helper = new InsightsChartHelper(this.data, this.selectedPortfolioIndex);
			this.categories = helper.initCategories();
			this.sectionTitle = helper.initHeaderInfo();
			const subHeader = helper.initSubHeaderInfo(this.categories);
			this.subHeaderValue = subHeader.subHeaderValue;
			this.subHeaderText = subHeader.subHeaderText;
			this.showSubHeaderContent = subHeader.showSubHeaderContent;
			this.emptyColumnChartAttributes = helper.initChartAttributes();
		}
	}

	public ngAfterViewInit(): void {
		if (this.element.nativeElement.querySelector('#left-content-wrapper')) {
			this.height = this.element.nativeElement.querySelector('#left-content-wrapper').offsetHeight + 1;
			this.ref.detectChanges();
		}
	}

	public isDisplaying(category): boolean {
		return new InsightsChartHelper(this.data, this.selectedPortfolioIndex).isDisplaying(category);
	}
}
